import { Link } from 'react-router-dom';
import './403.css';

export default function Error403 ({role})
{
    
    return (
        <div className="  text-warpper   ">
            <div className="title" data-content={ 404 }>
                404 Access DENIED
            
            </div>   
            <div className="subtitle">
                Oop, you do not have premetion to access to this page 
                <Link to={ "/login" } className=' d-block text-center btn btn-primary'> {role==="1996"?"go to writer page":"go to login page" }</Link>

            </div>


</div>

    );
}